const injectLink = (href) => {
    if (!href || typeof document === 'undefined')
        return;
    const selector = `link[rel="preload"][as="image"][href="${href}"]`;
    if (document.head.querySelector(selector))
        return;
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = href;
    link.setAttribute('fetchpriority', 'high');
    document.head.appendChild(link);
};
/** Preload des Hero-LCP-Bildes so früh wie möglich (mobile vs. desktop). */
export const preloadHeroLcpImage = (mobileSrc, desktopSrc) => {
    if (typeof window === 'undefined')
        return;
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    injectLink(isMobile ? mobileSrc : desktopSrc);
};
